<template>
  <div class="sf-tree-menu__item-icon">
    <workflow-review-checkmark
      v-if="reviewItem.shouldRender"
      :review="reviewItem.review"
      :reviews="reviewItem.reviews"
      hide-tooltip="true"
      icon-size="sf-font-s"
    />
  </div>
</template>
<script setup lang="ts">
import type { WorkflowReviewStatusData } from '@app/shared/types/sf-data'

import isEqual from 'lodash/isEqual'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

import WorkflowReviewCheckmark from '@app/application/workflows/sections/workflow-review-checkmark.vue'

import { useWorkflowOverview } from '@app/application/workflow-overview-navigation/store/overview'

type LocalReviewItem = {
  reviews: WorkflowReviewStatusData['reviews']
  review: WorkflowReviewStatusData['review']
  shouldRender: boolean
}

interface Props {
  itemId: number
}

const props = withDefaults(defineProps<Props>(), {
  itemId: 0,
})

const reviewItem = ref<LocalReviewItem>({
  reviews: [],
  review: null,
  shouldRender: false,
})

const overviewStore = useWorkflowOverview()

const { itemAndGroupReviewsById } = storeToRefs(overviewStore)

watch(
  itemAndGroupReviewsById,
  (newValue, oldValue) => {
    if (
      newValue[props.itemId]?.review !== oldValue?.[props.itemId]?.review ||
      !isEqual(
        newValue[props.itemId]?.reviews,
        oldValue?.[props.itemId]?.reviews
      )
    ) {
      reviewItem.value = {
        reviews: newValue[props.itemId]?.reviews,
        review: newValue[props.itemId]?.review,
        shouldRender: !!newValue[props.itemId],
      }
    }
  },
  {
    immediate: true,
  }
)
</script>
